import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import ProtectedRoute from './protected-route';
import DashboardPage from '../page/dashboard-page';
import HomeLayout from '../layout/home-layout/home-layout';
import ClientGroupsPage from '../page/client-groups-page';
import ClientsPage from '../page/clients-page';
import DataMappingPage from '../page/data-mapping-page';
import PDFBuilderPage from '../page/pdf-builder-page';
import ScriptEditorPage from '../page/script-editor-page';
import ScriptReferencePage from '../page/script-reference-page';
import LoginPage from '../page/login-page';
import TransmissionLogsPage from '../page/transmission-logs-page';
import UsersPage from '../page/admin-page';
import DepartmentMappingPage from '../page/department-mapping-page';
import CourtMappingPage from '../page/court-mapping-page';
import CitationsPage from '../page/citations-page';

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/login"
          element={<LoginPage />}
        />

        <Route element={<ProtectedRoute />} >
          <Route
            element={<HomeLayout />}>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/client-groups" element={<ClientGroupsPage />} />
            <Route path="/clients" element={<ClientsPage />} />
            <Route path="/script-editor/:clientId" element={<ScriptEditorPage />} />
            <Route path="/data-mapping/:clientId" element={<DataMappingPage />} />
            <Route path="/pdf-builder/:clientId" element={<PDFBuilderPage />} />
            <Route path="/pdf-builder" element={<PDFBuilderPage />} />
            <Route path="/users" element={<UsersPage />} />
            <Route path="/script-references" element={<ScriptReferencePage />} />
            <Route path="/transmission-logs" element={<TransmissionLogsPage />} />
            <Route path="/department-mapping" element={<DepartmentMappingPage />} />
            <Route path="/court-mapping" element={<CourtMappingPage />} />
            <Route path="/citations" element={<CitationsPage />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  )
};

export default AppRoutes;